module.exports = __webpack_public_path__ + "img/code-function-e7fe95d2.png";